package ar.corzo.health_tracker.utils

import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.LocalTime
import kotlinx.datetime.format.Padding
import kotlinx.datetime.format.char


val dateTimeFormat = LocalDateTime.Format{
    dayOfMonth()
    char('/')
    monthNumber()
    char('/')
    year()
    char(' ')
    hour()
    char(':')
    minute()
    char(':')
    second()
}
val hourMinuteTimeFormat = LocalTime.Format{
    hour()
    char(':')
    minute()
}
val dateFormat = LocalDate.Format{
    dayOfMonth()
    char('/')
    monthNumber()
    char('/')
    year()
}
val dateFormatNoPad = LocalDate.Format{
    dayOfMonth(Padding.NONE)
    char('/')
    monthNumber(Padding.NONE)
    char('/')
    year(Padding.NONE)
}